import React, { useState, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';
const SenceCardB = () => {
    const { t } = useLang('Delta3AirStation.SenceCardB');

    const contentList: any = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1762248020808/20251104-171913.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1762248020808/20251104-171913.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1762247453762/Frame%202094654267-pc.jpg',
            desc: t('desc1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761569526444/sence-card-2-pc%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761569526444/sence-card-2-pc%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761654016174/Frame%202094654268.jpg',
            desc: t('desc2'),
        },
    ];

    useCardsShowHook('#List-sence-D .card-box', '#List-sence-D');

    return (
        <section className={`${styles.SenceCardB} range4 GtmModuleData-section`} id="List-sence-D" data-section-id="SenceCardB">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
            </div>
            <div className="content-box">
                {contentList.map((item: any, index: number) => (
                    <div className="card-box" key={index}>
                        <div className="sence-img">
                            <EcoImg alt={item.desc} pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                        </div>
                        <div className="card-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default SenceCardB;
